var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    { staticClass: "grid grid-cols-2 grid-flow-row md:table-row" },
    [
      _c(
        "td",
        {
          staticClass:
            "md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
        },
        [_vm._v(" Order ")]
      ),
      _c(
        "td",
        {
          staticClass:
            "px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
        },
        [
          _c(
            "a",
            {
              staticClass: "text-blue-500",
              attrs: { href: _vm.orderUrl, target: "_blank" }
            },
            [_vm._v(" " + _vm._s(_vm.order.orderNumber) + " ")]
          )
        ]
      ),
      _c(
        "td",
        {
          staticClass:
            "md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
        },
        [_vm._v(" Date ")]
      ),
      _c(
        "td",
        {
          staticClass:
            "px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 text-gray-500"
        },
        [
          _vm._v(
            " " + _vm._s(_vm._f("dateFilter")(_vm.order.createdDate)) + " "
          )
        ]
      ),
      _c(
        "td",
        {
          staticClass:
            "md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
        },
        [_vm._v(" Customer Name ")]
      ),
      _c(
        "td",
        {
          staticClass:
            "px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
        },
        [
          _c(
            "a",
            {
              staticClass: "text-blue-500 cursor-pointer",
              on: {
                click: function($event) {
                  return _vm.$emit(
                    "openCustomerInfo",
                    _vm.order.customer.phoneNumber
                  )
                }
              }
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.order.customer.firstName) +
                  " " +
                  _vm._s(_vm.order.customer.lastName) +
                  " "
              )
            ]
          )
        ]
      ),
      _c(
        "td",
        {
          staticClass:
            "md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
        },
        [_vm._v(" Total ")]
      ),
      _c(
        "td",
        {
          staticClass:
            "px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
        },
        [_vm._v(" " + _vm._s(_vm.order.totalPrice) + " ")]
      ),
      _c(
        "td",
        {
          staticClass:
            "md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
        },
        [_vm._v(" Payment ")]
      ),
      _c(
        "td",
        {
          staticClass:
            "px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
        },
        [
          _c(
            "span",
            {
              staticClass:
                "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium",
              class: {
                "bg-gray-100": _vm.order.financialStatus === "paid",
                "bg-yellow-100": _vm.order.financialStatus !== "paid"
              }
            },
            [_vm._v(" " + _vm._s(_vm.order.financialStatus) + " ")]
          )
        ]
      ),
      _c(
        "td",
        {
          staticClass:
            "md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
        },
        [_vm._v(" Fulfillment ")]
      ),
      _c(
        "td",
        {
          staticClass:
            "px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
        },
        [
          _c(
            "span",
            {
              staticClass:
                "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium",
              class: {
                "bg-gray-100": _vm.order.fullfillmentStatus === "fulfilled",
                "bg-yellow-100": _vm.order.fullfillmentStatus !== "fulfilled"
              }
            },
            [_vm._v(" " + _vm._s(_vm.fullfillmentStatus) + " ")]
          )
        ]
      ),
      _c(
        "td",
        {
          staticClass:
            "md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
        },
        [_vm._v(" Message Sent ")]
      ),
      _c(
        "td",
        {
          staticClass:
            "px-1 md:px-1 py-2 md:py-4 border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
        },
        _vm._l(_vm.order.templateName, function(template, index) {
          return _c(
            "span",
            {
              key: index,
              staticClass:
                "inline-flex mx-1 my-1 items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800"
            },
            [_vm._v(" " + _vm._s(template) + " ")]
          )
        }),
        0
      ),
      _c(
        "td",
        {
          staticClass:
            "px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
        },
        [
          _c("div", { staticClass: "mt-2" }, [
            _vm.order.customerMeta && _vm.order.customerMeta.shouldNotDisturb
              ? _c(
                  "span",
                  {
                    staticClass:
                      "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-indigo-100 text-indigo-800"
                  },
                  [
                    _vm._v(" Do not disturb "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "flex-shrink-0 ml-1.5 inline-flex text-indigo-500 focus:outline-none focus:text-indigo-700",
                        attrs: {
                          type: "button",
                          "aria-label": "Remove small badge"
                        },
                        on: {
                          click: function($event) {
                            return _vm.removeTag("shouldNotDisturb")
                          }
                        }
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "h-2 w-2",
                            attrs: {
                              stroke: "currentColor",
                              fill: "none",
                              viewBox: "0 0 8 8"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "stroke-linecap": "round",
                                "stroke-width": "1.5",
                                d: "M1 1l6 6m0-6L1 7"
                              }
                            })
                          ]
                        )
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm.order.customerMeta && _vm.order.customerMeta.isNotOnWhatsapp
              ? _c(
                  "span",
                  {
                    staticClass:
                      "inline-flex mx-1 items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-indigo-100 text-indigo-800"
                  },
                  [
                    _vm._v(" Not on Whatsapp "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "flex-shrink-0 ml-1.5 inline-flex text-indigo-500 focus:outline-none focus:text-indigo-700",
                        attrs: {
                          type: "button",
                          "aria-label": "Remove small badge"
                        },
                        on: {
                          click: function($event) {
                            return _vm.removeTag("isNotOnWhatsapp")
                          }
                        }
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "h-2 w-2",
                            attrs: {
                              stroke: "currentColor",
                              fill: "none",
                              viewBox: "0 0 8 8"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "stroke-linecap": "round",
                                "stroke-width": "1.5",
                                d: "M1 1l6 6m0-6L1 7"
                              }
                            })
                          ]
                        )
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm.order.orderTags
              ? _c(
                  "span",
                  _vm._l(_vm.order.orderTags.split(","), function(tag, index) {
                    return _c(
                      "span",
                      {
                        key: index,
                        staticClass:
                          "inline-flex mx-1 items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-indigo-100 text-indigo-800"
                      },
                      [_vm._v(" " + _vm._s(tag) + " ")]
                    )
                  }),
                  0
                )
              : _vm._e()
          ]),
          _c(
            "div",
            { staticClass: "mt-2" },
            [_c("AddTagDropdown", { on: { onItemClicked: _vm.addTag } })],
            1
          )
        ]
      ),
      _c(
        "td",
        {
          staticClass:
            "px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap text-right border-b border-gray-200 text-xs leading-5 font-medium"
        },
        [_c("OrderSendMessage", { attrs: { order: _vm.order } })],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }